<mat-list-item>
  <mat-icon matListItemIcon>payments</mat-icon>
  <span matListItemTitle class="payment-title">
    <span class="payment-amount">{{ payment.amount }}&nbsp;&#8381; — {{ payment.payment_method_display }}</span>
    <mat-chip *ngIf="payment.is_paid" class="chip-paid">Оплачен</mat-chip>
    <mat-chip *ngIf="!payment.is_paid" class="chip-unpaid">Не оплачен</mat-chip>
  </span>
  <span matListItemLine *ngIf="payment.payment_date">{{ formatDateTime(payment.payment_date) }}</span>
  <span matListItemLine *ngIf="payment.description" class="payment-desc">{{ payment.description }}</span>
  <button mat-icon-button matListItemMeta color="warn"
          (click)="onDelete()"
          aria-label="Удалить платёж">
    <mat-icon>delete</mat-icon>
  </button>
</mat-list-item>
